export function geMerchantTemplateData(merchantTemplate, lang) {
  if (merchantTemplate.placeholders) {
    var merchantPlaceholders = getMerchantPlaceholder(
      merchantTemplate.placeholders,
      lang
    );
  }
  if (merchantTemplate.styles) {
    var merchantStyles = geMerchantStyles(merchantTemplate.styles);
  }
  if (merchantTemplate.configs) {
    var merchantConfigs = geMerchantConfigs(merchantTemplate.configs);
  }

  return {
    templateName: merchantTemplate.template,
    placeholders: merchantPlaceholders,
    styles: merchantStyles,
    fields: merchantTemplate.fields,
    configs: merchantConfigs,
    merchantId: merchantTemplate.merchantId,
    merchantName: merchantTemplate.merchantName,
    texts: merchantTemplate.texts,
  };
}
function getMerchantPlaceholder(placeholders, lang) {
  var merchantPlaceholders = {};
  if (placeholders) {
    placeholders.forEach((placeholder) => {
      if (placeholder.placeholder == 1) {
        if (placeholder.type == 1) {
          merchantPlaceholders.bannerColor = placeholder.value;
          merchantPlaceholders.bannerImage = 'none';
        } else if (placeholder.type == 2) {
          merchantPlaceholders.bannerImage = placeholder.value;
          merchantPlaceholders.bannerColor = 'none';
        }
      } else if (placeholder.placeholder == 2) {
        if (placeholder.type == 2) {
          merchantPlaceholders.logo = placeholder.value;
        }
      } else if (placeholder.placeholder == 3) {
        if (placeholder.type == 1) {
          merchantPlaceholders.backgroundColor = placeholder.value;
          merchantPlaceholders.backgroundImage = 'none';
        } else if (placeholder.type == 2) {
          merchantPlaceholders.backgroundImage = placeholder.value;
          merchantPlaceholders.backgroundColor = 'none';
        }
      } else if (placeholder.placeholder == 4) {
        merchantPlaceholders.btnTextColor = placeholder.value;
      } else if (placeholder.placeholder == 5) {
        merchantPlaceholders.btnColor = placeholder.value;
      }
      // get success screen msgs
      else if (placeholder.placeholder == 6) {
        merchantPlaceholders.successTitle = getLocalizedSuccessMsgs(
          placeholder.value,
          lang
        );
      } else if (placeholder.placeholder == 7) {
        merchantPlaceholders.successMessage = getLocalizedSuccessMsgs(
          placeholder.value,
          lang
        );
      } else if (placeholder.placeholder == 8) {
        merchantPlaceholders.successBtnText = getLocalizedSuccessMsgs(
          placeholder.value,
          lang
        );
      }
    });
  }
  return merchantPlaceholders;
}

function getLocalizedSuccessMsgs(val, lang) {
  //let val.replace(/(\\n)/gm, '').replace(/(\\")/gm, '"');
  return JSON.parse(val)[lang === 'ar' ? 'Ar' : lang === 'en' ? 'En' : 'Fr'];
}

function geMerchantStyles(styles) {
  var merchantStyles = {};
  if (styles) {
    styles.forEach((style) => {
      if (style.style == 1) {
        merchantStyles.isButtonRounded = style.value == 1 ? false : true;
      } else if (style.style == 2) {
        merchantStyles.fontColor = style.value;
      }
    });
  }
  return merchantStyles;
}

function geMerchantConfigs(configs) {
  let merchantConfigs = { isHybridPayment: false };
  if (configs) {
    configs.forEach((config) => {
      if (config.key === 'IsMultipleProducts') {
        merchantConfigs.IsMultipleProducts = config.value == 1 ? true : false;
      } else if (config.key === 'HideTerms&Conditions') {
        merchantConfigs.HideTermsAndConditions =
          config.value == 1 ? true : false;
      } else if (config.key === 'EnableHybridSolution') {
        merchantConfigs.isHybridPayment = config.value == 1 ? true : false;
      } else if (config.key === 'SeparateDCBFromWallets') {
        merchantConfigs.SeparateDCBFromWallets =
          config.value == 1 ? true : false;
      }
    });
  }
  return merchantConfigs;
}

export default { geMerchantTemplateData };
